import client from "../Client/HttpClient";
import {IRoutesModel} from "@/interfaces/modules";
const ApiPath = "SystemRoutes";

export default {
    GetRoute:(): Promise <IRoutesModel[]> => client.get(`${ApiPath}`),
    GetRouteById: (data: IRoutesModel ):Promise<IRoutesModel>=>client.get(`${ApiPath}/${data.Id}`),
    PostRoute : (data:IRoutesModel ) : Promise<IRoutesModel>=>client.post(`${ApiPath}`, data),
  };